/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportProductsBySign
 */
export interface ReportProductsBySign {
    /**
     * 
     * @type {object}
     * @memberof ReportProductsBySign
     */
    details: object;
    /**
     * 
     * @type {object}
     * @memberof ReportProductsBySign
     */
    sum: object;
}

export function ReportProductsBySignFromJSON(json: any): ReportProductsBySign {
    return ReportProductsBySignFromJSONTyped(json, false);
}

export function ReportProductsBySignFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportProductsBySign {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'details': json['details'],
        'sum': json['sum'],
    };
}

export function ReportProductsBySignToJSON(value?: ReportProductsBySign | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'details': value.details,
        'sum': value.sum,
    };
}


